<template>
  <div>
    <!-- 导航条 -->
    <top-nav></top-nav>
    <!-- 背景图 -->
    <img
      v-if="bannerList.length !== 0"
      :src="bannerList[0].CompanyName"
      class="img-fluid bg-img"
    />
    <!-- 面包屑 -->
    <div style="background-color: #f5f5f5;">
      <div class="crumbs_wrap type_area">
        <i class="iconfont iconweizhi1"></i>
        <span>您当前所在的位置：</span>
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">首页</li>
          <li class="breadcrumb-item active" aria-current="page">关于我们</li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ crumbs }}
          </li>
        </ol>
      </div>
    </div>
    <!-- 关于我们 -->
    <div class="brand_wrap">
      <div class="dynamic_wrap type_area">
        <div class="dynamic_title">
          <div>关于我们</div>
          <div>ABOUT US</div>
        </div>

        <!-- 选项切换 -->
        <div class="cut_tier_wrap">
          <div
            :class="[
              'tier_item',
              enterCurrentIndex == item.Id ? 'enter_active' : ''
            ]"
            v-for="item in navSonList"
            :key="item.Id"
            @click="handleEnterActive(item)"
          >
            {{ item.Title }}
          </div>
        </div>

        <!-- 广场简介 开始 -->
        <div
          class="show_wrap"
          v-html="introduction.CompanyLogo"
          v-if="enterCurrentIndex == 158"
        ></div>
        <!-- 广场简介 结束 -->

        <!-- 企业文化 开始 -->
        <div class="culture_wrap" v-else-if="enterCurrentIndex == 159">
          <img :src="enterprise.CompanyPhone" class="img-fluid" />
          <div class="culture_title_box" v-html="enterprise.CompanyLogo"></div>
        </div>
        <!-- 企业文化 结束 -->

        <!-- 招募英才 开始 -->
        <div class="recruit_wrap" v-else-if="enterCurrentIndex == 166">
          <nav class="nav top_box">
            <a
              class="nav-link disabled top_item"
              href="#"
              tabindex="-1"
              aria-disabled="true"
            >
              招聘职位
            </a>
            <a
              class="nav-link disabled top_item"
              href="#"
              tabindex="-1"
              aria-disabled="true"
            >
              所在地区
            </a>
            <a
              class="nav-link disabled top_item"
              href="#"
              tabindex="-1"
              aria-disabled="true"
            >
              要求学历
            </a>
            <a
              class="nav-link disabled top_item"
              href="#"
              tabindex="-1"
              aria-disabled="true"
            >
              招聘人数
            </a>
            <a
              class="nav-link disabled top_item"
              href="#"
              tabindex="-1"
              aria-disabled="true"
            >
              发布日期
            </a>
          </nav>
          <div class="accordion" id="accordionExample">
            <div class="card" v-for="item in recruitList" :key="item.Id">
              <!-- id要和下面的 aria-labelledby 一致 -->
              <div class="card-header" :id="`heading${item.Id}`">
                <button
                  class="btn btn-link btn-block text-left"
                  type="button"
                  data-toggle="collapse"
                  :data-target="`#collapseOne${item.Id}`"
                  aria-expanded="true"
                  :aria-controls="`collapseOne${item.Id}`"
                >
                  <nav class="nav">
                    <a
                      class="nav-link disabled"
                      href="#"
                      tabindex="-1"
                      aria-disabled="true"
                    >
                      {{ item.CompanyName }}
                    </a>
                    <a
                      class="nav-link disabled"
                      href="#"
                      tabindex="-1"
                      aria-disabled="true"
                    >
                      {{ item.CompanyPhone }}
                    </a>
                    <a
                      class="nav-link disabled"
                      href="#"
                      tabindex="-1"
                      aria-disabled="true"
                    >
                      {{ item.PosiType }}
                    </a>
                    <a
                      class="nav-link disabled"
                      href="#"
                      tabindex="-1"
                      aria-disabled="true"
                    >
                      {{ item.People }}
                    </a>
                    <a
                      class="nav-link disabled"
                      href="#"
                      tabindex="-1"
                      aria-disabled="true"
                    >
                      {{ item.CreationTime.substr(0, 10) }}
                    </a>
                  </nav>
                </button>
              </div>

              <!-- id要和上面button中的 data-target aria-controls一致 -->

              <!-- aria-labelledby 要和上面id一样 -->
              <div
                :id="`collapseOne${item.Id}`"
                class="collapse"
                :aria-labelledby="`heading${item.Id}`"
                data-parent="#accordionExample"
              >
                <div class="card-body">
                  <p>职位要求</p>
                  <span v-html="item.CompanyLogo"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 招募英才 结束 -->
      </div>
    </div>
    <!-- 底部 -->
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from '../../components/top-nav'
import bottomFooter from '../../components/bottom-footer'
export default {
  components: { topNav, bottomFooter },

  data() {
    return {
      // 顶部大图数据
      bannerList: [],
      // 关于我们切换
      enterCurrentIndex: 0,
      // 面包屑导航
      crumbs: '',
      // 子级导航
      navSonList: [],
      // 广场简介
      introduction: {},
      // 企业文化
      enterprise: {},
      // 招募英才列表
      recruitList: [],
      // 手机 || 电脑
      showTo: 0
    }
  },

  created() {
    if (
      navigator.userAgent.match(
        /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i
      )
    ) {
      this.showTo = 2
    } else {
      this.showTo = 1
    }
    this.getBannerList()
    this.getSubtopicList()
  },

  methods: {
    // 获取顶部大图
    async getBannerList() {
      const { data: res } = await this.$request.post(
        `/SX_Company/GetBannerList?SxType=${this.$route.query.id}&ShowTo=${this.showTo}`
      )
      this.bannerList = res.data
    },

    // 获取子栏目列表
    async getSubtopicList() {
      const { data: res } = await this.$request.post(
        `/SX_Company/GetDhangZiList?ParentId=${this.$route.query.id}`
      )
      this.navSonList = res.data
      if (this.$route.query.sonId) {
        this.enterCurrentIndex = +this.$route.query.sonId
        const res1 = this.navSonList.find(v => v.Id === this.enterCurrentIndex)
        this.handleEnterActive(res1)
      } else {
        this.handleEnterActive(res.data[0])
      }
    },

    // 获取广场简介
    async getIntroduction(id) {
      const { data: res } = await this.$request.post(
        `/SX_SquareDynamic/GetGchangJjie?SxType=${id}&ShowTo=${this.showTo}`
      )
      this.introduction = res.data
    },

    // 获取企业文化
    async getEnterprise(id) {
      const { data: res } = await this.$request.post(
        `/SX_SquareDynamic/GetGchangJjie?SxType=${id}&ShowTo=${this.showTo}`
      )
      this.enterprise = res.data
    },

    // 招募英才
    async getRecruitingList() {
      const { data: res } = await this.$request.post('/SX_TongYong/GetJobList')
      this.recruitList = res.data
    },

    handleEnterActive(item) {
      this.enterCurrentIndex = item.Id
      this.crumbs = item.Title
      // 广场简介
      if (item.Id === 158) {
        this.getIntroduction(item.Id)
      } else if (item.Id === 159) {
        // 企业文化
        this.getEnterprise(item.Id)
      } else {
        // 招募英才
        this.getRecruitingList()
      }
    }
  }
}
</script>

<style lang="less" scoped>
// 面包屑
.crumbs_wrap {
  display: flex;
  align-items: center;
  font-size: 14px;
  height: 30px !important;
  color: #666;

  .iconfont {
    color: #c41a26;
    font-size: 20px;
    padding-right: 10px;
  }
}

// 关于我们
.brand_wrap {
  .cut_tier_wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 0 50px;
    .tier_item {
      padding: 0 15px;
      margin: 0 12px;
      font-size: 16px;
      color: #333;
      cursor: pointer;
    }

    .tier_item:hover {
      text-align: center;
      height: 36px;
      line-height: 36px;
      color: #feeb09 !important;
      background-color: #b92e32;
      border-radius: 100px;
    }
  }

  .show_wrap {
    position: relative;
  }

  .culture_wrap {
    display: flex;
    align-items: center;
    .img-fluid {
      width: 678px;
      // height: 352px;
    }

    .culture_title_box {
      padding-top: 25px;
      padding-left: 108px;
      color: #333;

      div {
        font-size: 18px;
        font-weight: 600;
      }

      p {
        margin-bottom: 0;
        padding: 15px 0;
      }
    }
  }

  .recruit_wrap {
    .top_box {
      border-bottom: 3px solid #b92e32;
      .top_item {
        color: #333;
        padding: 0.65rem 0;
        width: 200px;
        text-align: center;
      }
    }

    .accordion > .card:not(:last-of-type) {
      border-bottom: none;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    .accordion {
      .card {
        border: none;
        margin-top: 1rem;

        .card-header {
          border-radius: 3px;
          border: 1px solid #ddd;
          padding: 0.65rem 0;
          margin-bottom: 0;

          .btn-link {
            padding: 0;

            .nav {
              .nav-link {
                color: #333;
                padding: 0;
                width: 200px;
                text-align: center;
              }
            }
          }

          .btn-link:hover {
            text-decoration: none;
            color: #333;
            text-decoration: none;
          }

          .btn-link:focus {
            text-decoration: none;
            box-shadow: none;
          }
        }

        .collapse {
          border: 1px solid #ddd;
          border-radius: 3px;
          .card-body {
            padding: 0.75rem 1.25rem;
            font-size: 14px;
            color: #666;
            p {
              font-size: 18px;
              color: #333;
              font-weight: 600;
            }
          }
        }

        .collapsing {
          border: 1px solid #ddd;
          .card-body {
            padding: 0.75rem 1.25rem;
            font-size: 14px;
            color: #666;
            p {
              font-size: 18px;
              color: #333;
              font-weight: 600;
            }
          }
        }
      }
    }
  }
}

// 通用
.dynamic_wrap {
  padding: 70px 0;

  .dynamic_title {
    text-transform: uppercase;
    text-align: center;
    div:nth-child(1) {
      padding-bottom: 17px;
      font-size: 30px;
      color: #b92e32;
    }

    div:nth-child(2) {
      align-items: center;
      font-size: 16px;
      color: #999;
    }
  }
}

// 关于我们切换
.enter_active {
  text-align: center;
  height: 36px;
  line-height: 36px;
  color: #feeb09 !important;
  background-color: #b92e32;
  border-radius: 100px;
}

// bootstrap
.breadcrumb {
  padding: 0;
  margin: 0;
  border-radius: 0;
  background-color: transparent;
}

// pc版心
.type_area {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

@media screen and (max-width: 480px) {
  .type_area {
    width: 375px;
  }

  .iconfont {
    padding: 0 10px;
  }

  .dynamic_wrap {
    padding: 30px 0;
  }

  .brand_wrap {
    .show_wrap {
      padding: 0 20px;
    }

    .cut_tier_wrap {
      padding: 30px 0;
      .tier_item {
        padding: 0 12px;
        margin: 0;
      }
    }

    .culture_wrap {
      display: block;
      padding: 0 20px;

      .img-fluid {
        width: 100%;
        // height: 310px;
      }
      .culture_title_box {
        padding-left: 0;
      }
    }

    .recruit_wrap {
      .top_box {
        padding: 0 10px;
        justify-content: center;
        font-size: 12px;
        .top_item {
          width: 70px;
        }
      }

      .accordion {
        .card {
          margin: 1rem 10px 0;
        }
        .nav {
          justify-content: center;
          font-size: 12px;
          .nav-link {
            width: 70px !important;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 767px) and (min-width: 480px) {
  .type_area {
    width: 640px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .type_area {
    width: 768px;
  }
}

/* 1024-1200px */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .type_area {
    width: 970px;
  }
}

/* 大于1200 px */
@media screen and (min-width: 1200px) {
  .type_area {
    width: 1200px;
  }
}
</style>
